/**
 * Regex to validate the input. Every of the following is accepted as being valid:
 * 1:30am, 01:30pm - the spaces are removed and the regex is used as case insensitive.
 * */
const timeRegex = /^[0-1]?\d:[0-5]\d[\s]?(am|pm)$/i;

/**
 * Function to validate time set manually from editable content element
 * @param {String} manualTime - Time set manually by the user.
 * @param {function} setTimeCallback - Function to be called if the time is correctly formatted.
 * @param {function} resetTimeCallback - Function to be called if the time is not correctly formatted.
 * */
export const validateManualTime = (
  manualTime,
  setTimeCallback,
  resetTimeCallback,
) => {
  let manualTimeString = manualTime.trim().replace(/\s/g, '').toLowerCase();
  const isValid = !!manualTimeString.match(timeRegex);

  if (!isValid) {
    resetTimeCallback();
    return;
  }

  const timeString = manualTimeString.slice(0, manualTimeString.length - 2);
  const meridiem = manualTimeString
    .slice(manualTimeString.length - 2)
    .toUpperCase();
  const [manualHourStr, manualMinutesStr] = timeString.split(':');
  const manualHour = Number.parseInt(manualHourStr, 10);
  const minutes = Number.parseInt(manualMinutesStr, 10);

  if (manualHour > 12) {
    resetTimeCallback();
    return;
  }

  let hours =
    meridiem === 'AM'
      ? manualHour === 12
        ? 0
        : manualHour
      : manualHour === 12
        ? manualHour
        : manualHour + 12;

  setTimeCallback({ hours, minutes });
};
